import { Component, ErrorInfo } from 'react';
import Title from '@/components/Title';

interface Props {
  children: JSX.Element;
}

interface State {
  hasError: boolean;
  errorMessage: string | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    const { hasError, errorMessage } = this.state;

    if (hasError) {
      const detail = import.meta.env.DEV && errorMessage ? `: ${errorMessage}` : '';
      return <Title>Something went wrong{detail}</Title>;
    }

    const { children } = this.props;

    return children;
  }
}

export default ErrorBoundary;
